import { useState, useEffect } from "react";
import { Radio } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCalendarCheck,
  faHourglassEnd,
} from "@fortawesome/free-solid-svg-icons";
import "./ApplicationStatusFilter.scss";
import { BaseFilterProps } from "interfaces/filter-component-base";
import { OptionItem } from "components/options-checkbox-filter/OptionsCheckboxFilter";

const statusOptions: OptionItem[] = [
  {
    value: "pending",
    label: "Pending",
    description: "Awaiting review",
    icon: faClock,
    iconClassName: "status-pending",
  },
  {
    value: "accepted",
    label: "Booked",
    description: "Confirmed booking",
    icon: faCalendarCheck,
    iconClassName: "status-booked",
  },
  {
    value: "expired",
    label: "Expired",
    description: "Time limit passed",
    icon: faHourglassEnd,
    iconClassName: "status-expired",
  },
];

interface ApplicationStatusFilterProps extends BaseFilterProps {
  className?: string;
}

const ApplicationStatusFilter = (props: ApplicationStatusFilterProps) => {
  const { onChangeValues, values, className } = props;
  const [selectedStatus, setSelectedStatus] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (values && typeof values === "string") {
      setSelectedStatus(values);
    } else if (values && Array.isArray(values) && values.length > 0) {
      setSelectedStatus(values[0]);
    } else {
      setSelectedStatus(undefined);
    }
  }, [values]);

  const handleStatusChange = (e: any) => {
    const status = e.target.value;
    setSelectedStatus(status);
    if (onChangeValues) {
      onChangeValues(status);
    }
  };

  return (
    <div className={`application-status-radio-items ${className || ""}`}>
      <Radio.Group
        value={selectedStatus}
        onChange={handleStatusChange}
        className="application-status-radio-group"
      >
        {statusOptions.map((option) => (
          <label key={option.value} className="application-status-radio-item">
            {option.icon && (
              <div
                className={`application-status-radio-icon ${
                  option.iconClassName || ""
                }`}
              >
                <FontAwesomeIcon icon={option.icon} />
              </div>
            )}
            <div className="application-status-radio-content">
              <p className="application-status-radio-content-title">
                {option.label}
              </p>
              {option.description && (
                <p className="application-status-radio-content-description">
                  {option.description}
                </p>
              )}
            </div>
            <div className="application-status-radio">
              <Radio value={option.value} />
            </div>
          </label>
        ))}
      </Radio.Group>
    </div>
  );
};

export default ApplicationStatusFilter;
